export default {"src":"/_next/static/image/public/images/no_slots_available.5ba275104ab31c96c5adff0924291fb3.svg","height":89,"width":101};